import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdVetaCenterReadinessItems } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { VetaCenterReadinessItem } from '~hooks/useVetaCenter/models';
import { VETA_CENTER_POLL_INTERVAL_IN_MS } from '~hooks/useVetaCenter/useVetaCenterPollWindow';
import { getVetaCenterReadinessItemsQueryKey } from '~queries/vetaCenterReadinessItemsQueryKey';
import connection from '~services/connectionModule';

export default function useVetaCenterReadinessItemsQuery(
  companyId: string,
  { isEnabled, isPolling = false }: { isEnabled: boolean; isPolling?: boolean },
) {
  const { data, isError, isFetching, isLoading, refetch } = useQuery({
    queryKey: getVetaCenterReadinessItemsQueryKey(companyId),
    queryFn:
      companyId && isEnabled
        ? async ({ signal }) => {
            try {
              const response = await getV1CompaniesCompanyIdVetaCenterReadinessItems({
                path: { 'company-id': companyId },
                signal,
              });

              return response.data.data.map(VetaCenterReadinessItem.parse);
            } catch (error) {
              connection.handleRequestError(
                error,
                t('error_messages.veta_center.failed_to_fetch_readiness_items'),
              );
            }
          }
        : skipToken,
    refetchInterval: ({ state }) =>
      isPolling && state.status !== 'error' ? VETA_CENTER_POLL_INTERVAL_IN_MS : false,
    retry: false,
  });

  return { isError, isFetching, isLoading, items: data ?? [], refetch };
}
